import { cellVariants } from './logic';

type TableCellProps = {
  /** セル内に表示するコンテンツ */
  children: React.ReactNode;
  /** サイズ。デフォルト: 'default' */
  size?: 'default' | 'md' | 'lg';
  /** テキストの寄せ方向。デフォルト: 'left' */
  align?: 'left' | 'center' | 'right';
  /** 追加のクラス名 */
  className?: string;
};

export const TableCell: React.FC<TableCellProps> = ({
  children,
  size = 'default',
  align = 'left',
  className,
}) => (
  <td className={[cellVariants({ size, align }), className].filter(Boolean).join(' ')}>
    {children}
  </td>
);
